(function () {
  'use strict';

  function videoSource(value) {
    let url;
    try { url = new URL(value, window.location.href); } catch (_) { return null; }
    if (!['https:', 'http:'].includes(url.protocol)) return null;
    const host = url.hostname.replace(/^www\./, '');
    if (['youtube.com', 'm.youtube.com', 'youtube-nocookie.com', 'youtu.be'].includes(host)) {
      const id = host === 'youtu.be' ? url.pathname.split('/')[1]
        : (url.searchParams.get('v') || url.pathname.match(/^\/(?:embed|shorts)\/([^/]+)/)?.[1]);
      if (!id || !/^[\w-]+$/.test(id)) return null;
      return { tag: 'iframe', src: `https://www.youtube-nocookie.com/embed/${id}?autoplay=1` };
    }
    if (['vimeo.com', 'player.vimeo.com'].includes(host)) {
      const match = url.pathname.match(/^\/(?:video\/)?(\d+)(?:\/([\w]+))?\/?$/);
      if (!match) return null;
      const embed = new URL(`https://player.vimeo.com/video/${match[1]}`);
      embed.searchParams.set('autoplay', '1');
      const hash = url.searchParams.get('h') || match[2];
      if (hash) embed.searchParams.set('h', hash);
      return { tag: 'iframe', src: embed.href };
    }
    if (/\.(mp4|webm|ogg)$/i.test(url.pathname)) return { tag: 'video', src: url.href };
    return null;
  }

  function init() {
    document.querySelectorAll('[data-bas-pdp="gallery"]').forEach(function (gallery) {
      if (gallery.dataset.basGalleryInitialized === 'true') return;
      gallery.dataset.basGalleryInitialized = 'true';
      const slides = Array.from(gallery.querySelectorAll('[data-bas-gallery-slide]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-bas-gallery-thumb]'));
      const trigger = gallery.querySelector('[data-bas-gallery-video-trigger]');

      function pause(slide) {
        slide.querySelectorAll('video, model-viewer').forEach(function (media) {
          if (typeof media.pause === 'function') media.pause();
        });
        slide.querySelectorAll('iframe').forEach(function (frame) {
          const src = frame.getAttribute('src');
          if (src) frame.setAttribute('src', src);
        });
      }

      function select(index, focus) {
        if (!slides[index]) return;
        slides.forEach(function (slide, i) {
          if (i !== index && !slide.hidden) pause(slide);
          slide.hidden = i !== index;
          slide.classList.toggle('is-active', i === index);
        });
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-selected', String(i === index));
          thumb.tabIndex = i === index ? 0 : -1;
        });
        if (trigger) trigger.hidden = !!slides[index].querySelector('video, iframe, model-viewer');
        if (focus && thumbs[index]) thumbs[index].focus();
      }

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () { select(index, false); });
        thumb.addEventListener('keydown', function (event) {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % slides.length;
          if (event.key === 'ArrowLeft') next = (index + slides.length - 1) % slides.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = slides.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(next, true);
        });
      });

      if (trigger) {
        let dialog;
        trigger.addEventListener('click', function (event) {
          const source = videoSource(trigger.dataset.videoUrl);
          if (!source || typeof HTMLDialogElement === 'undefined') return;
          event.preventDefault();
          slides.forEach(pause);
          if (!dialog) {
            dialog = document.createElement('dialog');
            dialog.className = 'bas-pdp-gallery__dialog';
            dialog.setAttribute('aria-label', trigger.getAttribute('aria-label') || 'Product video');
            gallery.appendChild(dialog);
            dialog.addEventListener('close', function () {
              dialog.replaceChildren();
              trigger.focus();
            });
            dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
          }
          const close = document.createElement('button');
          close.type = 'button';
          close.className = 'bas-pdp-gallery__close';
          close.setAttribute('aria-label', 'Close video');
          close.textContent = '\u00d7';
          close.addEventListener('click', function () { dialog.close(); });
          const player = document.createElement(source.tag);
          player.src = source.src;
          player.className = 'bas-pdp-gallery__video';
          if (source.tag === 'video') {
            player.controls = true;
            player.autoplay = true;
            player.playsInline = true;
          } else {
            player.title = 'Product video';
            player.allow = 'autoplay; fullscreen; picture-in-picture';
            player.allowFullscreen = true;
          }
          dialog.replaceChildren(close, player);
          dialog.showModal();
          close.focus();
        });
      }
      select(0, false);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
